import { render } from "./ReferencePage.vue?vue&type=template&id=0cf6f99c&scoped=true"
import script from "./ReferencePage.vue?vue&type=script&lang=js"
export * from "./ReferencePage.vue?vue&type=script&lang=js"

import "./ReferencePage.vue?vue&type=style&index=0&id=0cf6f99c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf6f99c"]])

export default __exports__